import React from "react";
import I18n from "i18n-js";
import { arrayOf, func, shape, string, bool } from "prop-types";

const today = new Date();
const isFuture = (date) => new Date(date) > today;
const isPast = (date) => new Date(date) < today;
const isCurrent = (certificate, enterprise) => {
  return (
    certificate.number ===
    enterprise?.certificateOfProfessionalCompetence?.number
  );
};
const isBetween = (date, startDate, endDate) => {
  return (
    new Date(date) >= new Date(startDate) && new Date(date) <= new Date(endDate)
  );
};

const CertificatesList = ({
  certificates,
  loading,
  enterprise,
  onAdd,
  onDelete,
}) => {
  const certs = [...certificates];
  const currentCert = certs.find((cert) =>
    isBetween(
      today,
      cert.startDate,
      cert.endDate
    )
  );

  if (currentCert) {
    enterprise.certificateOfProfessionalCompetence = currentCert;
  } else {
    if (
      enterprise?.certificateOfProfessionalCompetence?.number &&
      certs.filter(
        (cert) =>
          cert.number === enterprise.certificateOfProfessionalCompetence.number
      ).length === 0
    ) {
      certs.push({
        number: enterprise.certificateOfProfessionalCompetence.number,
        startDate: new Date(
          enterprise.certificateOfProfessionalCompetence.startDate
        )
          .toISOString()
          .split("T")[0],
        endDate: new Date(
          enterprise.certificateOfProfessionalCompetence.endDate
        )
          .toISOString()
          .split("T")[0],
      });
      certs.sort((a, b) => new Date(a.startDate) - new Date(b.startDate));
    }
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h3>{I18n.t("pages.clients.certificates.title")}</h3>
        <button onClick={onAdd} className="btn btn-primary">
          <i className="fa fa-plus" aria-hidden="true" />
        </button>
      </div>
      <div
        className="d-flex align-items-center bg-white rounded-lg"
        style={{
          backgroundColor: "#f0f0f0",
          minHeight: "100px",
          overflow: "scroll",
        }}
      >
        {loading ? (
          <div className="loader" />
        ) : certs.length === 0 ? (
          <div className="d-flex flex-column align-items-center justify-content-center w-100">
            <i className="fa fa-ban" aria-hidden="true" />
            <div>{I18n.t("pages.clients.certificates.empty")}</div>
          </div>
        ) : (
          certs.map((cert) => (
            <div
              key={cert.uuid}
              className={`d-flex flex-column gap-2 p-2 m-2 rounded-lg ${
                isCurrent(cert, enterprise)
                  ? "certificate-card-current"
                  : isPast(cert.endDate)
                  ? "certificate-card-past"
                  : isFuture(cert.startDate)
                  ? "certificate-card-future"
                  : "certificate-card-past"
              }`}
            >
              <div className="d-flex justify-content-between align-items-center font-weight-bold">
                <div>{I18n.t("pages.clients.certificates.number")}</div>
                {isFuture(cert.startDate) && (
                  <div>
                    <button
                      onClick={() => onDelete(cert.uuid)}
                      className="delete-certificate"
                    >
                      <i
                        className="fa fa-trash text-white"
                        aria-hidden="true"
                      />
                    </button>
                  </div>
                )}
              </div>
              <div>{cert.number}</div>
              <div className="font-weight-bold">
                {I18n.t("pages.clients.certificates.validityDate")}
              </div>
              <div>{`${cert.startDate} - ${cert.endDate}`}</div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

CertificatesList.propTypes = {
  certificates: arrayOf(
    shape({
      uuid: string,
      number: string,
      startDate: string,
      endDate: string,
    })
  ).isRequired,
  loading: bool.isRequired,
  enterprise: shape({
    certificateOfProfessionalCompetence: shape({
      number: string,
      startDate: string,
      endDate: string,
    }),
  }).isRequired,
  onAdd: func.isRequired,
  onDelete: func.isRequired,
};

export default CertificatesList;
